export default "__VITE_ASSET__CSL0itk0__"